import { render } from "./LessonPreviewPage.vue?vue&type=template&id=845ed562&ts=true"
import script from "./LessonPreviewPage.vue?vue&type=script&lang=ts"
export * from "./LessonPreviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__